import api from "../../../shared/services/api";

// BI de tráfego — credenciais e contas (/api/ads). O token nunca volta do backend.
export async function fetchResumo() { return (await api.get("/ads/resumo")).data; }

export async function fetchTokens() { return (await api.get("/ads/tokens")).data.data; }
export async function conectarToken({ provider, token, business_id }) {
    return (await api.post("/ads/tokens", { provider, token, business_id })).data;
}
export async function revalidarToken(id) { return (await api.post(`/ads/tokens/${id}/revalidar`)).data; }
export async function removerToken(id) { return (await api.delete(`/ads/tokens/${id}`)).data; }

export async function fetchContas() { return (await api.get("/ads/contas")).data.data; }
export async function setContaAtiva(id, ativo) { return (await api.put(`/ads/contas/${id}`, { ativo })).data; }
export async function sincronizarConta(id, dias = 3) { return (await api.post(`/ads/contas/${id}/sync`, { dias })).data; }
export async function fetchPixelsConta(id) { return (await api.get(`/ads/contas/${id}/pixels`)).data.data; }
